import Slick from './Slick.vue';

export default Slick;
